/**
 * 权限常量定义
 * 统一管理所有权限标识，避免硬编码和配置不一致
 */

// 主菜单权限
export const MENU_PERMISSIONS = {
  DASHBOARD: 'dashboard',
  STATISTICS: 'statistics',
  CONTENT: 'content',
  NOTIFICATION: 'notification',
  ACCOUNT: 'account',
  PLATFORM_SETTINGS: 'platform-settings',
  PERSONAL: 'personal',
  HELP: 'help',
  TEST_TOOLS: 'test-tools',
} as const;

// 子菜单权限
export const SUB_MENU_PERMISSIONS = {
  // 操作台子菜单
  DASHBOARD_OPERATION_DESK: 'dashboard.operation-desk',
  DASHBOARD_COMPREHENSIVE: 'dashboard.comprehensive',

  // 内容管理子菜单
  CONTENT_ABNORMAL: 'content.abnormal',
  CONTENT_ALL: 'content.all',
  CONTENT_CONTENT_ANALYSIS: 'content.content-analysis',

  // 通知管理子菜单
  NOTIFICATION_INBOX: 'notification.inbox',
  NOTIFICATION_SEND: 'notification.send',
  NOTIFICATION_HISTORY: 'notification.history',

  // 账号管理子菜单
  ACCOUNT_SCHOOL: 'account.school-account',
  ACCOUNT_EDUCATION: 'account.education-account',
  ACCOUNT_MEDIA: 'account.media-account',
  ACCOUNT_SCHOOL_ANALYSIS: 'account.school-analysis',

  // 平台设置子菜单
  PLATFORM_ABNORMAL_DATA: 'platform-settings.abnormal-data',
  PLATFORM_TAG_LIBRARY: 'platform-settings.tag-library',
  PLATFORM_ROLE_MANAGEMENT: 'platform-settings.role-management',
  PLATFORM_OPERATION_LOG: 'platform-settings.operation-log',
  PLATFORM_SYSTEM_CONFIG: 'platform-settings.system-config',
  PLATFORM_SCHOOL_TAG_MANAGEMENT: 'platform-settings.school-tag-management',
  PLATFORM_ARTICLE_PULL_CACHE: 'platform-settings.article-pull-cache',
  HELP_DOCUMENT_MANAGEMENT: 'help.document-management',

  // 个人中心子菜单
  PERSONAL_USER_INFO: 'personal.user-info',
  PERSONAL_SUB_ACCOUNT: 'personal.sub-account',
  PERSONAL_CHANGE_PASSWORD: 'personal.change-password',

  // 帮助子菜单
  HELP_DOCUMENT_VIEW: 'help.document-view',

  // 测试工具子菜单
  TEST_TOOLS_CONTENT_TEST: 'test-tools.content-test',
  TEST_TOOLS_ACCOUNT_RELATION_TEST: 'test-tools.account-relation-test',
} as const;

// 所有权限（用于类型检查）
export const ALL_PERMISSIONS = {
  ...MENU_PERMISSIONS,
  ...SUB_MENU_PERMISSIONS,
} as const;

export type MenuPermission = typeof MENU_PERMISSIONS[keyof typeof MENU_PERMISSIONS];
export type SubMenuPermission = typeof SUB_MENU_PERMISSIONS[keyof typeof SUB_MENU_PERMISSIONS];
export type AllPermission = typeof ALL_PERMISSIONS[keyof typeof ALL_PERMISSIONS];
